import { normalizeNail } from './design-model.js';

export function clearTargets(scope, active, selected = []) {
  if (!Number.isInteger(active) || active < 0 || active > 9) return [];
  if (scope === 'ten') return Array.from({ length: 10 }, (_, i) => i);
  if (scope === 'five') return Array.from({ length: 5 }, (_, i) => Math.floor(active / 5) * 5 + i);
  if (scope === 'selected') return [...new Set(selected)].filter(i => Number.isInteger(i) && i >= 0 && i < 10);
  return [active];
}

export function clearNailArtwork(design, indices) {
  const targets = new Set(indices);
  return { ...design, nails: design.nails.map((nail, i) => targets.has(i)
    // Zero base opacity is already supported by draft, sharing and server validation.
    // Build a bare nail, rather than restoring the colored starter inspiration.
    ? normalizeNail({ color: 'pearl-white', opacity: 0, finish: 'glossy', layers: [] })
    : nail) };
}
